import { Link } from 'react-router-dom';

const articles = [
  {
    path: '/itaobuy-spreadsheet-scarpe',
    title: 'Itaobuy Spreadsheet Scarpe',
    excerpt: 'Scopri le migliori sneakers, modelli sportivi e casual con foto QC dettagliate. La guida completa per trovare le scarpe perfette su Itaobuy Spreadsheet.',
    image: 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20pristine%20white%20leather%20sneakers%20photographed%20from%20a%20low%20angle%20on%20a%20sunlit%20cobblestone%20street%20in%20an%20italian%20village%2C%20warm%20golden%20hour%20light%20casting%20long%20shadows%2C%20mediterranean%20architecture%20background%20with%20pastel%20walls%2C%20lifestyle%20fashion%20editorial%20photography&width=600&height=400&seq=card-scarpe&orientation=landscape'
  },
  {
    path: '/itaobuy-spreadsheet-felpe',
    title: 'Itaobuy Spreadsheet Felpe',
    excerpt: 'Hoodie, crewneck e maglioni di qualità con foto QC. Tutto quello che devi sapere per scegliere la felpa perfetta su Itaobuy Spreadsheet.',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20oversized%20cream%20knit%20sweater%20draped%20over%20a%20wooden%20chair%20on%20a%20terrace%20overlooking%20the%20amalfi%20coast%2C%20soft%20morning%20light%20with%20sea%20breeze%2C%20mediterranean%20lifestyle%20photography%2C%20warm%20neutral%20tones%20with%20azure%20sea%20background&width=600&height=400&seq=card-felpe&orientation=landscape'
  },
  {
    path: '/itaobuy-spreadsheet-t-shirt',
    title: 'Itaobuy Spreadsheet T-Shirt',
    excerpt: 'Magliette basic e grafiche per ogni stile. Guida alle foto QC per riconoscere la qualità del cotone su Itaobuy Spreadsheet.',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20premium%20cotton%20t-shirts%20in%20muted%20earth%20tones%20folded%20on%20a%20rustic%20wooden%20stool%20in%20a%20sunlit%20tuscan%20farmhouse%20kitchen%2C%20terracotta%20floor%20tiles%20and%20dried%20herbs%20hanging%2C%20warm%20authentic%20italian%20countryside%20aesthetic&width=600&height=400&seq=card-tshirt&orientation=landscape'
  },
  {
    path: '/itaobuy-spreadsheet-giacche',
    title: 'Itaobuy Spreadsheet Giacche',
    excerpt: 'Bomber, denim jacket e giubbotti con foto QC. Consigli pratici per valutare materiali e rifiniture prima dell\'acquisto.',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20olive%20green%20bomber%20jacket%20hanging%20on%20a%20brass%20coat%20hook%20against%20a%20textured%20plaster%20wall%20in%20a%20milan%20loft%20apartment%2C%20soft%20afternoon%20light%20streaming%20through%20tall%20windows%2C%20urban%20italian%20fashion%20editorial%2C%20warm%20industrial%20aesthetic&width=600&height=400&seq=card-giacche&orientation=landscape'
  },
  {
    path: '/itaobuy-spreadsheet-accessori',
    title: 'Itaobuy Spreadsheet Accessori',
    excerpt: 'Occhiali, orologi, gioielli e piccola pelletteria. Come valutare i dettagli più piccoli con le foto QC su Itaobuy Spreadsheet.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20tortoiseshell%20sunglasses%20a%20vintage%20gold%20watch%20and%20a%20leather%20bracelet%20arranged%20on%20aged%20marble%20surface%20with%20a%20single%20olive%20branch%2C%20soft%20natural%20light%20from%20balcony%2C%20italian%20luxury%20still%20life%20photography%2C%20refined%20mediterranean%20aesthetic&width=600&height=400&seq=card-accessori&orientation=landscape'
  },
  {
    path: '/itaobuy-spreadsheet-borse',
    title: 'Itaobuy Spreadsheet Borse',
    excerpt: 'Zaini, tracolla e tote bag selezionate. Guida alla scelta della borsa perfetta con foto QC dettagliate.',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20cognac%20leather%20tote%20bag%20sitting%20on%20a%20wooden%20bench%20in%20a%20sun%20dappled%20piazza%20in%20florence%2C%20soft%20golden%20light%20filtering%20through%20cypress%20trees%2C%20renaissance%20architecture%20in%20background%2C%20italian%20artisanal%20lifestyle%20photography&width=600&height=400&seq=card-borse&orientation=landscape'
  },
  {
    path: '/itaobuy-spreadsheet-sneakers',
    title: 'Itaobuy Spreadsheet Sneakers',
    excerpt: 'Jordan, Dunk, Yeezy e modelli ricercati. La checklist definitiva per valutare le sneakers con le foto QC.',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20premium%20sneakers%20arranged%20in%20a%20creative%20semicircle%20on%20a%20concrete%20ledge%20with%20a%20vibrant%20street%20art%20mural%20backdrop%20in%20a%20milan%20urban%20setting%2C%20dynamic%20street%20style%20photography%2C%20youthful%20energy%2C%20sneaker%20culture%20aesthetic&width=600&height=400&seq=card-sneakers&orientation=landscape'
  },
  {
    path: '/itaobuy-spreadsheet-sicurezza',
    title: 'Itaobuy Spreadsheet Sicurezza',
    excerpt: 'Come acquistare in modo sicuro e protetto. Le 7 regole d\'oro, consigli pratici e checklist per evitare rischi.',
    image: 'https://readdy.ai/api/search-image?query=A%20shield%20icon%20glowing%20softly%20on%20a%20laptop%20screen%20with%20warm%20ambient%20lighting%20in%20a%20cozy%20home%20office%20setting%2C%20an%20olive%20plant%20and%20a%20ceramic%20mug%20nearby%2C%20feeling%20of%20digital%20safety%20and%20trust%2C%20calm%20protective%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=card-sicurezza&orientation=landscape'
  },
  {
    path: '/itaobuy-spreadsheet-come-usare',
    title: 'Come Usare Itaobuy Spreadsheet',
    excerpt: 'Tutorial completo passo dopo passo. Dalla prima apertura alla scelta del prodotto perfetto in soli 5 passi.',
    image: 'https://readdy.ai/api/search-image?query=Hands%20gently%20hovering%20over%20a%20laptop%20keyboard%20with%20a%20clean%20organized%20spreadsheet%20visible%20on%20screen%2C%20an%20open%20notebook%20with%20handwritten%20italian%20notes%20beside%20it%2C%20warm%20desk%20lamp%20glow%20on%20a%20wooden%20desk%2C%20tutorial%20and%20learning%20atmosphere%2C%20authentic%20editorial%20photography&width=600&height=400&seq=card-comeusare&orientation=landscape'
  },
];

export default function ArticlesSection() {
  return (
    <section id="articoli" className="py-16 md:py-24 bg-white">
      <div className="px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-tealwarm-700 uppercase tracking-wide mb-3">
            <span className="w-1.5 h-1.5 rounded-full bg-tealwarm-500"></span>
            Guide e Articoli
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-warm-950">
            Approfondimenti su{' '}
            <span className="text-tealwarm-600">Itaobuy Spreadsheet</span>
          </h2>
          <p className="mt-3 text-sm text-warm-500 max-w-xl mx-auto">
            Guide complete, tutorial e consigli pratici per sfruttare al massimo il tuo itaobuy spreadsheet. Contenuti originali in italiano ottimizzati per aiutarti a trovare i prodotti migliori.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group bg-cream-50 rounded-2xl overflow-hidden hover:shadow-md transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[3/2] overflow-hidden bg-cream-100">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-display text-lg font-bold text-warm-950 group-hover:text-tealwarm-700 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-warm-600 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-2 text-tealwarm-700 text-sm font-medium">
                  <span className="whitespace-nowrap">Leggi l&apos;articolo</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}